export default __webpack_public_path__ + "static/media/YELD.40c5a7f2.png";